module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/W737F/tc-custom/9781460303719.jpg?1699747137673",
      "alt": "This image is the cover for the book Billionaire's Baby Sos, The Larkville Legacy"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Billionaire's Baby Sos, The Larkville Legacy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Successful CEO Matt Patterson isn't called the Ice Man for nothinghe's built up his multibillion-dollar company through cool decision-making and a ruthless reputation. But now he has a new challenge to face"), _c('i', [_vm._v("fatherhood!")]), _c('br'), _c('br'), _vm._v("Finding himself guardian to gorgeous baby Bella, Matt's more comfortable in the boardroom than changing a diaper. Lucky, then, that social worker Claire Kincaid agrees to play temporary mom. Happy families might never have been in Matt's plans, but Claire and little Bella are opening his eyes to a life that money could never buy"), _c('br'), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Susan Meier\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Susan Meier spent most of her twenties thinking she was a job-hopper – until she began to write and realised everything that had come before was only research! One of eleven children, with twenty-four nieces and nephews and three kids of her own, Susan lives in Western Pennsylvania with her wonderful husband, Mike, her children, and two over-fed, well-cuddled cats, Sophie and Fluffy. You can visit Susan’s website at www.susanmeier.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0